import { DotsHorizontalIcon } from "@heroicons/react/solid";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import { React, useState, useEffect, useContext } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import ShowMoreText from "react-show-more-text";
import swal from "sweetalert";
import { serverInfo } from "../../App";
import Lock from "../../Assets/Images/Normal-User/lock.png";
import noImage from "../../Assets/Images/settings/no-image.png";
import "../../components/CSS/Home/Post.css";
import "../../components/CSS/Sidebar/Left/Enroll.css";
import MyVerticallyCenteredModal from "../../components/RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import { LocationContext } from "../../CustomHelper/Helper";
import Linkify from "react-linkify";

import PostReaction from "./PostReaction";
import {Waypoint} from "react-waypoint";

import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';


export default function SingleGeneralPost({ post, handleAllMuteToggle, playerRef, allMuted, volume, volumeChangeHandler }) {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);


  const { slectedCurrency, payStatus } = useContext(LocationContext);

  const [successShow, setSuccessShow] = useState(false);
  const [post_id, setPostId] = useState(false);
  const [payment_status, setPaymentStatus] = useState([]);
  const [postPayment, setPostPayment] = useState(post?.post_type);


  const [data, setData] = useState({
    likes: post.react_number,
    updated: false,
  });

  const makePayment = (id) => {
    setPostId(id);
    setSuccessShow(true);
  };

  const countryBasePaymentCount = (value) => {
    return (Number(value) * Number(slectedCurrency?.currency_value)).toFixed(0);
  };

  const handleSubmit = (id) => {
    //e.preventDefault();
    if (!data.updated) {
      setData({ likes: data.likes + 1, updated: true });
    } else {
      setData({ likes: data.likes - 1, updated: false });
    }

    axios.get(`/api/submit_react/${id}`).then((res) => {
      if (res.data.status === 200) {
      } else {
        swal("Warning", "failed", "warning");
      }
    });
  };


  let [shouldPlay, updatePlayState] = useState(false);

  let handleEnterViewport = function () {
    updatePlayState(true);
  };
  let handleExitViewport = function () {
    updatePlayState(false);
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      video::-moz-media-controls-volume-slider {
        display: none !important;
      }
      video::-moz-media-controls-volume-control-container {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    axios
      .get(`api/user/generalPost/payment/check/${post?.event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setPaymentStatus(res.data.payment_status);
        }

      });
  }, [post]);

  return (
    <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
      <div className="card PostCardBg ">
        <h2 className="accordion-header PostBack">
          <div className="d-flex justify-content-between">
            <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
              <img
                src={
                  post?.star?.image !== null && post.star?.image !=undefined
                    ? imageCdnUrl+post?.star?.image
                    : noImage
                }
                className="PostImgHome"
                alt="star-profile"
              />

              <span className="mx-2 text-warning text-light">
                <Link
                  to={`/starprofile/${post.user_id}`}
                  className="link-starPorfile"
                >
                  {post.star?.first_name} {post.star?.last_name}
                </Link>
                <br></br>
                <small className="category-size-chat">
                  {moment(post.created_at).format("LT")}
                  {" | "}
                </small>
                <small className="category-size-chat">
                  {moment(post.created_at).format("LL")}
                </small>
              </span>
            </div>
          </div>
        </h2>

        {/* <h5 className="my-2 Enroll-a Enroll-text text-justify">
          {post?.title}
        </h5> */}

        <ShowMoreText
          lines={3}
          more={<span>See more</span>}
          less={<span>See less</span>}
          className="content-css my-2 Enroll-a Enroll-text py-2"
          anchorClass="my-anchor-css-class"
          //onClick={executeOnClick}
          expanded={false}
          truncatedEndingComponent={"... "}
        >
          <Linkify properties={{ target: "_blank" }}>
            <Markup content={post?.details==null||post?.details=='null'?'':post?.details}></Markup>
          </Linkify>
        </ShowMoreText>


{post?.video !== null || post?.banner !== null ? (
          <>
            {Number(postPayment) !== 0 && payment_status == null ? (
              <div className="card PostCard">
                { post?.banner? (
                  <>
                    <img
                      src={imageCdnUrl+post?.banner}
                      alt="NoImage"
                      className={payment_status == null ? "img-blur" : null}
                    />

                    {payment_status == null ? (
                      <img
                        src={Lock}
                        alt=""
                        className="ImGCernter"
                        onClick={() => makePayment(post?.event_id)}
                      />
                    ) : null}
                    {/* <span className="dot2 d-flex justify-content-center align-items-center">
                      <img src={Lock} alt="" style={{ width: "200px" }} />
                    </span> */}
                    </>
                ) : (
                  <>
                    <div
                      className={payment_status == null ? "video-blur" : null}
                    >
                      <Waypoint scrollableAncestor='window' onEnter={handleEnterViewport} onLeave={handleExitViewport}>
                      <div>
                        <ReactPlayer
                        url={videoCdnUrl+post?.video}
                        playing={shouldPlay}
                        controls={true}
                        // className={payment_status == null ? "vide-blur" : null}
                        volume={1}
                        width="100%"
                        light={imageCdnUrl+post?.thumbnail}

                        height="500px" // style={{ margin: "0 auto" }}
                        />
                      </div>
                      </Waypoint>
                    </div>
                    {payment_status == null ? (
                      <img
                        src={Lock}
                        alt=""
                        className="ImGCernter"
                        onClick={() => makePayment(post?.event_id)}
                      />
                    ) : null}

                    {/* <span className="dot2 d-flex justify-content-center align-items-center">
                      <img src={Lock} alt="" style={{ width: "200px" }} />
                    </span> */}
                  </>
                )}
              </div>
            ):postPayment !== 0 && payment_status != null ?(
              <div className="card PostCard">
                {post?.banner ? (
                  <>
                      <img
                        src={imageCdnUrl+post?.banner}
                        alt="noImage"
                        className=""
                      />
                  </>
                ) : (
                  <>
                  <Waypoint scrollableAncestor='window' onEnter={handleEnterViewport} onLeave={handleExitViewport}>
                    <div>
                      <ReactPlayer
                        url={videoCdnUrl+post?.video}
                        playing={shouldPlay}
                        controls={true}
                        className=""
                        volume={1}
                        width="100%"
                        height="500px" // style={{ margin: "0 auto" }} onReady={()=> }
                      />
                    </div>
                  </Waypoint>
                  </>
                )}
              </div>
            ) : (
              <div className="card PostCard">
                {post?.video ? (
                  <>
                    {Number(post?.post_type) === 0 ? (
                        <Waypoint scrollableAncestor='window' onEnter={handleEnterViewport} onLeave={handleExitViewport}>
                          <div className="player-wrapper">
                            <ReactPlayer
                              className="react-player"
                              url={videoCdnUrl + post?.video}
                              playing={shouldPlay}
                              ref={playerRef}
                              muted={allMuted}
                              volume={volume}
                              controls={true}
                              width="100%"
                              height="500px" // style={{ margin: "0 auto" }} onReady={()=> }
                            />

                            <div className="customVolumeArea">                            
                              <p onClick={handleAllMuteToggle}>
                                  {allMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                             </p>
                                <div class="volume-container"> 
                                  <input type="range" id="volume" min="0" max="1" step="0.01" value={volume} onChange={volumeChangeHandler} />
                                </div>
                            </div>

                          </div>
                        </Waypoint>
                      ) : null}

                  </>
                ) : (
                  <>
                    {Number(post?.post_type) === 0 ? (
                      <>
                        <img
                          src={imageCdnUrl+post?.banner}
                          alt="noImage"
                          className=""
                        />
                      </>
                    ) : null}
                  </>
                )}
              </div>
            )}
          </>
        ) : (
          <></>
        )}


        <div className="ViewPost">
          <PostReaction post={post}></PostReaction>
        </div>
      </div>
      {payStatus && (
        <MyVerticallyCenteredModal
          show={successShow}
          onHide={() => setSuccessShow(false)}
          event_id={post_id}
          baseFee={Number(post?.post_type)}
          fee={countryBasePaymentCount(Number(post?.post_type))}
          event_type="generalpost"
          redirectTo="activities"
        />
      )}
    </div>
  );
}
